import environment from "../environment";
import errorMiddleware from "./errorMiddleware";
import { sentryMiddleware } from "./sentryMiddleware";
import { authMiddleware } from "@app/config/api/authMiddleware";
import { teamMiddleware } from "@app/config/api/teamMiddleware";
import type { paths } from "@generated/openapi";
import { QueryClient } from "@tanstack/react-query";
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      throwOnError: true
    }
  }
});

const fetchClient = createFetchClient<paths>({
  baseUrl: environment.ATI_API_BASE_URL,
  mode: "cors"
});

// the team middleware should run first so that on response the auth middleware
// can reset team and user information on 401
fetchClient.use(teamMiddleware, authMiddleware, sentryMiddleware, errorMiddleware);

const api = createClient(fetchClient);

export default api;
